"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateSortApi = updateSortApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 修改排序
 */
function updateSortApi(params) {
  return (0, _request.default)({
    url: "/admin/store/product/updateSort/".concat(params.id, "/").concat(params.sort),
    method: 'GET'
  });
}